import { createContext, useSyncExternalStore, type ReactNode } from 'react'

import type { ReportProblemProps } from './ReportProblem'

/**
 * Le ticket qu'une boîte ouverte monte dans son en-tête (#481) : sous une boîte, le bouton de la
 * navigation est recouvert par le voile, et c'est souvent dans la boîte qu'on voit le problème.
 *
 * Le `ReportProblem` de l'app s'y inscrit avec sa capture et son envoi ; `Modal` s'en sert pour
 * rendre un second `ReportProblem` **dans** sa carte, que la primitive traite alors en boîte
 * imbriquée : la boîte du dessous reste ouverte, et sa saisie avec.
 */
export type ReportSlot = (trigger: NonNullable<ReportProblemProps['trigger']>) => ReactNode

let slot: ReportSlot | null = null
const listeners = new Set<() => void>()

export function setReportSlot(next: ReportSlot | null) {
  slot = next
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useReportSlot(): ReportSlot | null {
  return useSyncExternalStore(
    subscribe,
    () => slot,
    () => null,
  )
}

/** Vrai dans une boîte : le ticket qu'on y ouvre ne prend pas la place de celui de l'app. */
export const InsideModal = createContext(false)
